import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Panel } from '../../../components/ui';
import { formatDate as formatDateTime } from '../../../lib/formatDate';
import { safeHref } from '../../../lib/mockupEvents';

export const formatDate = (value?: string | null) => formatDateTime(value, { time: true });

export const formatLabel = (key: string) =>
    key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (s) => s.toUpperCase())
        .trim();

export const InfoRow = ({ label, value }: { label: string; value?: React.ReactNode }) => (
    <Box
        sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '120px 1fr', sm: '140px 1fr' },
            gap: 1,
            py: 0.5,
            alignItems: 'start',
        }}
    >
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
            {label}
        </Typography>
        <Typography component="div" variant="body2" sx={{ fontWeight: 500, wordBreak: 'break-word', lineHeight: 1.5 }}>
            {value ?? '—'}
        </Typography>
    </Box>
);

/** One block of a submission; a Panel with the design system's header. */
export const SectionCard = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <Panel title={title} titleAs="h3">{children}</Panel>
);

export const EmptyValue = () => (
    <Box component="span" sx={{ color: 'text.disabled', fontStyle: 'italic' }}>—</Box>
);

export const displayValue = (value: unknown): React.ReactNode => {
    if (value === null || value === undefined || value === '') return <EmptyValue />;
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'string' && safeHref(value)) {
        return (
            <Link href={value} target="_blank" rel="noreferrer">
                {value}
            </Link>
        );
    }
    return String(value).trim() || <EmptyValue />;
};
